import { Authorization } from "./middleware";

export const User = Authorization;
